function ExpediaIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.723 7.697l-.404-1.142L7.896 1.98l.615-.153 5.902 5.102 3.474-.993c.408-.106.872-.128 1.225-.126A9.989 9.989 0 0013.385.584C8.171-1.274 2.438 1.45.583 6.666a9.977 9.977 0 00-.47 4.861l8.322-2.89 3.288-.94zM19.477 6.712c-.305.198-.753.457-1.197.6l-3.481.993-2.323 7.457-.603.196.49-5.695-.274-1.183-3.262.931-8.622 2.03a10.014 10.014 0 006.456 7.429c5.216 1.858 10.946-.867 12.8-6.08.8-2.248.75-4.592.016-6.678z"
        fill="#072F54"
      />
      <path
        d="M12.089 9.082l.275 1.181-.491 5.695.603-.196 2.323-7.455 3.48-.994c.445-.142.893-.404 1.198-.6-.107-.306-.23-.608-.365-.902-.353-.003-.817.021-1.225.125l-3.474.996L8.51 1.827l-.614.153 3.422 4.576.405 1.14-3.289.942-8.32 2.889c.026.173.056.345.091.515l8.623-2.03 3.261-.93z"
        fill="#FBC108"
      />
    </svg>
  )
}

export default ExpediaIcon
